var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.667.732l4.732 5.033-.008.007.022.024-5.459 5.117-1.367-1.459L18.204 7H0V5.015h19.052l-2.803-2.966L17.667.732z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0 1 1 0 7 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    d: "M21.693 5.744l-4.717 4.461-.683-.728L19.468 6.5H.5v-.985h19.713l-3.255-3.443.685-.636 4.05 4.308z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#40423F",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-3h24v24H-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.86e28bbba3ac5703e1097b60dc46525c.svg";
export { ForwardRef as ReactComponent };